var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 6.66667V4H6.66667V5.6H5.6V6.66667H4ZM17.3333 4H12V5.6H17.3333V4ZM22.6667 4V5.6H28V4H22.6667ZM33.3333 4V5.6H34.4V6.66667H36V4H33.3333ZM36 12H34.4V17.3333H36V12ZM36 22.6667H34.4V28H36V22.6667ZM36 33.3333H34.4V34.4H33.3333V36H36V33.3333ZM28 36V34.4H22.6667V36H28ZM17.3333 36V34.4H12V36H17.3333ZM6.66667 36V34.4H5.6V33.3333H4V36H6.66667ZM4 28H5.6V22.6667H4V28ZM4 17.3333H5.6V12H4V17.3333Z",
    fill: "#228C80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlaceholder);
export default __webpack_public_path__ + "static/media/ic_placeholder.c27601137550013526f7d4dbda148c5c.svg";
export { ForwardRef as ReactComponent };